import { Typography } from '@tractian/ui'
import { useTranslation } from 'react-i18next'

export type MatrixStatusProps = {
  /** Whether a stored override is currently applied. */
  hasActiveOverride: boolean
}

/** One-line status of the override, in the destructive colour while it is live. */
export function MatrixStatus({ hasActiveOverride }: MatrixStatusProps) {
  const { t } = useTranslation('matrix')

  return (
    <Typography.Text size="small" className={hasActiveOverride ? 'text-red-500' : 'text-gray-500'}>
      {hasActiveOverride ? t('status.overrideActive') : t('status.usingDefaults')}
    </Typography.Text>
  )
}
